import React, { useEffect, useRef } from "react";
import { useWeb3 } from "../context/Web3Context";
import { useToast } from "./common/Toast";
import ConnectWallet from "./ConnectWallet";
import Loader from "./common/Loader";
import { parseError } from "../utils/errors";

// Guarantees connected + correct (hidden) network before rendering the app.
// On wrong network we AUTO-switch once. No page reload — state updates in place.
export default function NetworkGuard({ children }) {
  const {
    booting,
    isConnected,
    isCorrectNetwork,
    switchNetwork,
    switching,
    targetNetworkName,
  } = useWeb3();
  const toast = useToast();
  const autoTried = useRef(false);

  useEffect(() => {
    if (isConnected && !isCorrectNetwork && !autoTried.current && !switching) {
      autoTried.current = true;
      switchNetwork()
        .then(() => toast.info("Network switched."))
        .catch((e) => toast.error(parseError(e)));
    }
    if (isCorrectNetwork) autoTried.current = false;
  }, [isConnected, isCorrectNetwork, switching, switchNetwork, toast]);

  if (booting) {
    return (
      <main className="app-content">
        <Loader text="Starting" fullscreen={false} />
      </main>
    );
  }

  if (!isConnected) return <ConnectWallet />;

  if (!isCorrectNetwork) {
    return (
      <main className="app-content">
        <div className="card center fade-up" style={{ marginTop: 40 }}>
          <div style={{ fontSize: 34, marginBottom: 6 }}>🔗</div>
          <h2 className="card-title">Switch Network</h2>
          <p className="muted">
            Your wallet is on a different network. Approve the switch to continue on{" "}
            {targetNetworkName}.
          </p>
          <button
            className="btn btn-block mt-4"
            onClick={() =>
              switchNetwork()
                .then(() => toast.info("Network switched."))
                .catch((e) => toast.error(parseError(e)))
            }
            disabled={switching}
          >
            {switching ? "Switching…" : `Switch to ${targetNetworkName}`}
          </button>
        </div>
      </main>
    );
  }

  return children;
}
